// removed by extract-text-webpack-plugin
module.exports = {"AppLink":"AppLink--3ujX3","icon":"icon--18dkg","cancel":"cancel--3Ofcx"};